import {HibuConfigurationState} from './config-types';
import {ConfigAction} from './config-actions';
import {TabType} from '../search/search-types';

const initialState: HibuConfigurationState = {
    uiConfig: {
        landingPage: {
            enabled: false
        },
        languageSwitcher: {
            enabled: false
        },
        sharedSavedSearches: {
            enabled: false
        },
        search: {
            enabled: false,
            resultListFields: {
                title: [],
                titleSeparator: ' | ',
                main: [],
                mainSeparator: ' | ',
                sub: [],
                subSeparator: ' | ',
                showFileTypeIcons: true,
            },
            enabledDetailsTabs: [TabType.CONTENT, TabType.SPOTLIGHT, TabType.CONTENT],
            spotlightTagTypes: [],
            detailFields: {
                detailTagTypes: [],
                detailMetadata: []
            },
            export: {
                enabled: false,
                toggles: {
                    html: false,
                    json: false
                }
            },
            tagsWithDropdown: [],
            tagDropdownOptions: {},
            tagsWithConfirmation: [],
            documentActions: {
                toggles: {
                    showLinkToClipboardButton: true,
                    showLinkByMailButton: true,
                    showDownloadButton: true,
                }
            }
        },
        analysis: {
            enabled: false
        },
        aiAssistant: {
            supportedTags: [],
            globalAssistant: {
                enabled: false
            },
            searchAssistant: {
                enabled: false,
                resultSetLimit: 1024
            },
            allDocsAssistant: {
                enabled: false
            },
            proposeQuestionsEnabled: false,
            helpModalContentEnglish: '',
            helpModalContentGerman: '',
        },
        settings: {
            enabled: false,
            toggles: {
                showUserId: false,
                showContainerName: false,
                showTechnicalDetails: false,
                showManualValidation: false,
                showFieldSpecificSearch: false,
            }
        },
        styleVariables: {},
        logoUrl: undefined,
        menuItems: []
    }
};

const applyStyles = (styleVariables: Record<string, string>) => {
    // set all styles from backend
    if (styleVariables) {
        Object.entries(styleVariables).forEach((entry) => {
            document.documentElement.style.setProperty('--' + entry[0], entry[1]);
        });
    }
};

export function configReducer(state: HibuConfigurationState = initialState, action: ConfigAction): HibuConfigurationState {
    switch (action.type) {
        case 'UI_CONFIG_LOADED': {
            applyStyles(action.uiConfig.styleVariables);
            return {
                ...state,
                uiConfig: action.uiConfig,
            };
        }
        case 'CONFIG_LOAD_TAG_OPTIONS_FINISHED': {
            state.uiConfig.search.tagDropdownOptions = action.tagOptions;
            return state;
        }
        default:
            return state;
    }
}
